<template>
  <div class="home">
    <div class="monitor bd1">
      <span class="text">日期展示</span>
      <div class="time">
        <el-date-picker
          v-model="value2"
          type="date"
           @change="chaneClick2"
          placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="time">
        <el-date-picker
          v-model="value1"
          type="date"
          @change="chaneClick1"
          placeholder="开始时间">
        </el-date-picker>
      </div>
    </div>
    <div class="echars">
      <div class="echar-one">
        <p class="red">
          PM2.5和PM10
        </p>
        <div id="myChart" class="myChart" v-if="value1 && value2"></div>
        <div v-else class="noDate">
          <img src="@/assets/img/home/noDate.png">
          <p>暂无数据</p>
        </div>
      </div>
      <div class="echar-one">
        <p class="blue">
          风速/风力
        </p>
        <div id="myChart1" class="myChart" v-if="value2"></div>
        <div v-else class="noDate">
          <img src="@/assets/img/home/noDate.png">
          <p>暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const echars1 = require('@/assets/img/home/echars1.png')
const echars2 = require('@/assets/img/home/echars2.png')
const echars3 = require('@/assets/img/home/echars3.png')
const echars4 = require('@/assets/img/home/echars4.png')
import { ByCollectTime } from '@/api/index'
export default {
  data() {
    return {
      value1: '',
      value2: '',
      timeArr: [],
      pm25: [],
      pm10: [],
      windSpeed: [], // 风速
      windPower: [], // 风力
    }
  },
  computed: {
  },
  methods: {
    chaneClick1 (value){
      this.value1 = value
    },
    chaneClick2 (value2){
      this.getDate(this.value1, value2)
      this.drawLine();
      this.windSpeedLine();
    },
    getDate(value1, value2 ) {
      var beginTime = ''
      var endTime = ''
      let date1 = new Date(value1)
      let date2 = new Date(value2)
      let Y1 = date1.getFullYear();
      let M1 = date1.getMonth() + 1;
      let D1 = date1.getDate();
      if(M1 < 10) {
        M1 = '0' + M1;
      }
      if(D1 < 10) {
        D1 = '0' + D1;
      }
      let Y2 = date2.getFullYear();
      let M2 = date2.getMonth() + 1;
      let D2 = date2.getDate();
      if(M2 < 10) {
        M2 = '0' + M2;
      }
      if(D2 < 10) {
        D2 = '0' + D2;
      }

      beginTime = Y1 + '-' + M1 + '-' + D1  + ' ' +'00:00:00';
      endTime = Y2 + '-' + M2 + '-' + D2  + ' ' +'00:00:00';

      ByCollectTime({
        type: 4,
        beginTime: beginTime,
        endTime: endTime,
        sn: this.$route.query.sn
      }).then(res => {
        var data = res.resultData
        this.pm25 = data.pm25
        this.pm10 = data.pm10
        this.windSpeed = data.windSpeed
        this.windPower = data.windPower
        this.timeArr = []
        for (let i = 0; i < data.time.length; i += 1) {
         this.timeArr.push(data.time[i].substring(5, 10))
        }
        this.drawLine();
        this.windSpeedLine();
      }).catch(err => {
        console.log(err)
      })
    },
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))

        //展示数据
        var xData = this.timeArr;
        var yValue2 = this.pm25
        var yValue3 = this.pm10
        // 绘制图表
        myChart.setOption({
        color: [ '#E43F3F', '#F19149'],
        tooltip: {
            show: true,
            trigger: 'axis',
            // backgroundColor: 'rgba(10, 69, 110,0.612)',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    color: '#1dc9f6'
                }
            },
        },
        legend: {
            right: '5%',
            top: '-2%',
            icon: 'circle',
            textStyle: { color: "#333" },
            data: [ 'PM2.5', 'PM10', ]
        },
        grid: {
            left: '9%',
            right: '5%',
            top: '15%',
            bottom: '20%'
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: { show: false },
            axisLine: {
                show: true,
                lineStyle: { color: '#BDBDBD', width: 1 }
            },
            axisLabel: {
                color: '#333',
                formatter: function (value) {
                    return value;
                }
            },
            data: xData
        },
        yAxis: {
            type: 'value',
            axisTick: { show: false },
            axisLine: {
                show: true,
                lineStyle: { color: '#BDBDBD', width: 1 }
            },
            axisLabel: {
                color: '#333',
                fontSize: 14,
                formatter: function (value) {
                    return value;
                }
            },
            splitLine: {
                show: true,
                lineStyle: { color: '#C8C8C8', width: 1, type: 'dotted' }
            }
        },
        dataZoom: [
            {
            type: 'slider',
            show: true,
            start: 0,
            end:50,
            bottom:'-3%',
            xAxisIndex: [0],
          },
        ],
        series: [
            {
                name: 'PM2.5',
                type: 'line',
                smooth: true,
                sampling: 'average',
                symbol: 'image://'+echars1+'',
                symbolSize: 6,
                lineStyle: {
                    normal: {
                        width: 2,
                    }
                },
                data: yValue2
            },
            {
                name: 'PM10',
                type: 'line',
                smooth: true,
                sampling: 'average',
                symbol: 'image://'+echars2+'',
                symbolSize: 6,
                lineStyle: {
                    normal: {
                        width: 2,
                    }
                },
                data: yValue3
            },
        ]
        });
    },
    // 风速风力
    windSpeedLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1'))

        //展示数据
        var xData = this.timeArr;
        var yValue2 = this.windSpeed
        var yValue3 = this.windPower
        // 绘制图表
        myChart.setOption({
        color: [ '#468CFF', '#6BC8A4'],
        tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    color: '#1dc9f6'
                }
            },
        },
        legend: {
            right: '5%',
            top: '-2%',
            icon: 'circle',
            textStyle: { color: "#333" },
            data: [ 'wind_speed', 'wind_power', ]
        },
        grid: {
            left: '9%',
            right: '5%',
            top: '15%',
            bottom: '20%'
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: { show: false },
            axisLine: {
                show: true,
                lineStyle: { color: '#BDBDBD', width: 1 }
            },
            axisLabel: {
                color: '#333',
                formatter: function (value) {
                    return value;
                }
            },
            data: xData
        },
       dataZoom: [
            {
            type: 'slider',
            show: true,
            start: 0,
            end:50,
            bottom:'-3%',
            xAxisIndex: [0],
          },
        ],
        yAxis: {
            type: 'value',
            axisTick: { show: false },
            axisLine: {
                show: true,
                lineStyle: { color: '#BDBDBD', width: 1 }
            },
            axisLabel: {
                color: '#333',
                fontSize: 14,
                formatter: function (value) {
                    return value;
                }
            },
            splitLine: {
                show: true,
                lineStyle: { color: '#C8C8C8', width: 1, type: 'dotted' }
            }
        },
        series: [
            {
                name: 'wind_speed',
                type: 'line',
                smooth: true,
                sampling: 'average',
                symbol: 'image://'+echars3+'',
                symbolSize: 6,
                lineStyle: {
                    normal: {
                        width: 2,
                    }
                },
                data: yValue2
            },
            {
                name: 'wind_power',
                type: 'line',
                smooth: true,
                sampling: 'average',
                symbol: 'image://'+echars4+'',
                symbolSize: 6,
                lineStyle: {
                    normal: {
                        width: 2,
                    }
                },
                data: yValue3
            },
        ]
        });
    },
  },
};
</script>

<style lang="less" scoped>
  .home{
    font-size:14px;
    .bd1{
        border-bottom:1px solid #F5F7FF;
    }
    .monitor{
      padding:0 10px;
      height:60px;
      line-height: 60px;
      background: #fff;
      vertical-align: middle;
      .text{
        margin-left:10px;
         color:#343434;
        font-size: 16px;
        vertical-align: middle;
        display: inline-block;
      }
      .time{
        float: right;
        color:#656565;
        font-size:12px;
        span{
          border:1px solid #ECECEC;
          color:#999;
          font-size:13px;
          background: #FCFCFC;
          padding:10px;
          border-radius: 5px;
        }
      }
    }
    .echars{
      .echar-one{
        padding:22px 10px 25px 10px;
        margin-bottom:10px;
        background:#fff;
        p{
          padding:7px 10px;
          display: inline-block;
          color:#fff;
          border-radius: 5px;
        }
        .red{
           background: #E43F3F;
        }
        .blue{
          background: #468CFF;
        }
        .green{
          background: #6BC8A4;
        }
        .myChart{
          height:220px;
          width:100%;
        }
        .noDate{
          text-align: center;
          margin: 0 auto;
          img{
            width:260px;
            height:270px;
            margin: 0 auto;
            display: block;
          }
          p{
            color:#888;
            font-size:24px;
            margin-top:20px;
          }
        }
      }
    }
  }
</style>
